import type { AuthTokens } from "@/types/auth.types";

export const AUTH_STORAGE_KEY = "auth_tokens";

export const authUtils = {
  // 保存令牌
  setTokens: (tokens: AuthTokens) => {
    localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(tokens));
  },

  // 获取令牌
  getTokens: (): AuthTokens | null => {
    const tokens = localStorage.getItem(AUTH_STORAGE_KEY);
    return tokens ? JSON.parse(tokens) : null;
  },

  // 清除令牌
  clearTokens: () => {
    localStorage.removeItem(AUTH_STORAGE_KEY);
  },

  // 检查是否已认证
  isAuthenticated: (): boolean => {
    const tokens = authUtils.getTokens();
    return !!tokens?.accessToken;
  },
};
